if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',

    class ShopTheLook extends HTMLElement {
      constructor() {
        super();
        this.containerID = this.getAttribute('data-id');
        this.container = document.getElementById(this.containerID);
        this.stl_items = this.container.querySelectorAll('.collection-itemlink');
        this.stlcloseO = this.container.querySelectorAll('.cc__stloverlay, .cc__stlclose');
      }

      connectedCallback() {
        this.stl_items.forEach(item => {
          item.addEventListener('click', this.openItem.bind(this));
        });

        this.stlcloseO.forEach(item => {
          item.addEventListener('click', this.closeItem.bind(this));
        });
      }

      openItem(e) {
        const targetUrl = e.currentTarget.getAttribute('data-target');
        document.getElementById(targetUrl)?.classList.add('stlopen');

        document.dispatchEvent(
          new CustomEvent('theme:resize:width', {
            bubbles: true,
          })
        );
      }

      closeItem(e) {
        const btn = e.currentTarget.closest('button');
        const targetClose = btn ? btn.dataset.close : null;

        if (targetClose) {
          document.getElementById(targetClose)?.classList.remove('stlopen');
          return;
        }

        e.currentTarget.closest('.stlopen')?.classList.remove('stlopen');
      }
    }
  );
}

if (!customElements.get('cc-quick-add')) {
  customElements.define(
    'cc-quick-add',

    class CCQuickAdd extends HTMLElement {
      constructor() {
        super();

        this.form             = this.querySelector('form');
        this.sectionID        = this.form.dataset.blockid;
        this.inputId          = this.form.querySelector('.qa-variant-id');
        
        this.form.addEventListener('submit', this.onSubmit.bind(this));

        this.submitButton     = this.form.querySelector('.cc_qa');
        this.selector         = this.querySelector('.cc_qa-selector');
        if( this.selector ){
          this.currentSel       = this.selector.querySelector('.cc_qa-current');
          this.options          = this.selector.querySelectorAll('.cc_qa-varitem');
        }
        this.productPrice     = document.querySelector(`#stl-${this.sectionID} .cc__stlprice`);

        this.productJSON      = this.querySelector('[data-productJSON]');
      }

      connectedCallback() {
        if( !this.selector ) return;
        this.options.forEach(item => {
          item.addEventListener('click', this.setCurrentVariant.bind(this));
        });

        this.selector.addEventListener('click', this.openOptions.bind(this));
      }

      setCurrentVariant(e) {
        // Prevent parent .cc_qa-selector click event from toggling again
        e.stopPropagation();

        const productId = e.currentTarget.getAttribute('data-id');
        this.inputId.value = productId;
        this.currentSel.textContent = e.currentTarget.innerText;

        // Close the dropdown
        this.selector.classList.remove('cc_qa-open');

        let currentJSON           = JSON.parse(this.productJSON.textContent);
        let currentData           = currentJSON.variants.find((item) => item.id == productId );
        let currentPrice          = currentData.price ? window.theme.formatMoney(currentData.price, theme.moneyFormat) : '';
        let currentPriceCompare   = currentData.compare_at_price ? window.theme.formatMoney(currentData.compare_at_price, theme.moneyFormat) : '';

        if( !currentPriceCompare ){
          this.productPrice.querySelector('.new-price').textContent = currentPrice;
        } else {
          this.productPrice.querySelector('.new-price').textContent = currentPrice;
          this.productPrice.querySelector('.old-price').textContent = currentPriceCompare;
        }
      }

      openOptions(e) {
        this.selector.classList.toggle('cc_qa-open');
      }

      onSubmit(e){
        e.preventDefault();

        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: this.submitButton,
            },
            bubbles: false,
          })
        );

      }

      toggleSubmitButton(disable = true, text = window.theme.strings.addToCart) {
        this.submitButton.toggleAttribute('disabled', disable);
        this.submitButtonText.textContent = text;
      }
    }
  );
}

// CART GIFT WRAP
if (!customElements.get('cc-gift-wrap')) {
  customElements.define(
    'cc-gift-wrap',

    class CCGiftWrap extends HTMLElement {
      constructor() {
        super();

        this.items = Array.from(this.querySelectorAll('[data-gift-wrap-item]')).map((row) => {
          const item = {
            root: row,
            variantId: parseInt(row.dataset.variantId, 10),
            checkbox: row.querySelector('[data-gift-wrap-checkbox]'),
            form: row.querySelector('[data-gift-wrap-form]'),
            submitButton: row.querySelector('[data-gift-wrap-submit]'),
            isUpdating: false,
          };

          item.onAddSuccess = () => this.onAddSuccess(item);
          item.onAddError = () => this.onAddError(item);

          return item;
        });

        this.onChange = this.onChange.bind(this);
        this.syncWithCart = this.syncWithCart.bind(this);
      }

      connectedCallback() {
        if (!this.items.length) return;

        this.addEventListener('change', this.onChange);

        this.items.forEach((item) => {
          item.submitButton?.addEventListener('theme:product:add', item.onAddSuccess);
          item.submitButton?.addEventListener('theme:product:add-error', item.onAddError);
        });

        document.addEventListener('theme:cart:refresh', this.syncWithCart);
        document.addEventListener('theme:cart:change', this.syncWithCart);

        // Reconcile checkboxes with the live cart in case it changed elsewhere (e.g. line item removed from the cart list)
        this.syncWithCart();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);

        this.items.forEach((item) => {
          item.submitButton?.removeEventListener('theme:product:add', item.onAddSuccess);
          item.submitButton?.removeEventListener('theme:product:add-error', item.onAddError);
        });

        document.removeEventListener('theme:cart:refresh', this.syncWithCart);
        document.removeEventListener('theme:cart:change', this.syncWithCart);
      }

      onChange(event) {
        const checkbox = event.target.closest('[data-gift-wrap-checkbox]');
        if (!checkbox) return;

        const row = checkbox.closest('[data-gift-wrap-item]');
        const item = this.items.find((entry) => entry.root === row);
        if (!item || item.isUpdating) return;

        if (checkbox.checked) {
          this.addGiftWrap(item);
        } else {
          this.removeGiftWrap(item);
        }
      }

      toggleBusy(item, isBusy) {
        item.isUpdating = isBusy;
        item.checkbox.disabled = isBusy;
        item.root.classList.toggle('is-loading', isBusy);
      }

      /**
       * Add a gift wrap product, preferring window.Shopify.actions.cart when a host app
       * provides it, otherwise falling back to the theme's own default "Add to cart"
       * broadcast (`theme:cart:add`), the same event used by product forms and quick add.
       */
      addGiftWrap(item) {
        if (!item.form || !item.submitButton) return;

        this.toggleBusy(item, true);

        const shopifyCartActions = window.Shopify && window.Shopify.actions && window.Shopify.actions.cart;

        if (shopifyCartActions && typeof shopifyCartActions.addItem === 'function') {
          try {
            shopifyCartActions.addItem(
              {id: item.variantId, quantity: 1},
              {
                success: item.onAddSuccess,
                error: item.onAddError,
              }
            );

            return;
          } catch (error) {
            console.log(error);
          }
        }

        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: item.submitButton,
            },
            bubbles: false,
          })
        );
      }

      onAddSuccess(item) {
        this.toggleBusy(item, false);
      }

      onAddError(item) {
        this.toggleBusy(item, false);
        item.checkbox.checked = false;
      }

      /**
       * The theme has no dedicated broadcast event for cart removal, so update the cart
       * directly and let the theme's own `theme:cart:refresh` listener re-render the cart.
       *
       * Uses /cart/update.js with the `updates` map (keyed by variant ID) rather than
       * /cart/change.js's `id`/`line` params, since the latter needs the line's position
       * and can silently no-op if that position is wrong or stale.
       */
      removeGiftWrap(item) {
        this.toggleBusy(item, true);

        fetch(window.theme.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({updates: {[item.variantId]: 0}}),
        })
          .then((response) => response.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          })
          .catch((error) => console.log(error))
          .finally(() => {
            this.toggleBusy(item, false);
          });
      }

      getCart() {
        return fetch(`${window.theme.routes.cart_url}.js`, {
          headers: {Accept: 'application/json'},
        }).then((response) => response.json());
      }

      /**
       * Keep the checkbox(es) in sync with the live cart, and make sure gift wrap
       * never lingers by itself when no other real product remains in the cart.
       */
      syncWithCart() {
        if (this.items.some((item) => item.isUpdating)) return;

        this.getCart()
          .then((cart) => {
            const knownVariantIds = this.items.map((item) => item.variantId);
            const hasOtherProducts = cart.items.some((line) => !knownVariantIds.includes(line.variant_id));

            this.items.forEach((item) => {
              const lineItem = cart.items.find((line) => line.variant_id === item.variantId);
              item.checkbox.checked = Boolean(lineItem);

              if (lineItem && !hasOtherProducts) {
                this.removeGiftWrap(item);
              }
            });
          })
          .catch((error) => console.log(error));
      }
    }
  );
}
// END CART GIFT WRAP

// CUSTOM TAB COLLECTIONS
document.querySelectorAll('.tab-link').forEach((item)=>{
  item.addEventListener('click', et=>{
      let sectionidd = et.currentTarget.dataset.section;
      let dataurl = et.currentTarget.dataset.url;

      if( sectionidd && dataurl ){
          document.getElementById(sectionidd).querySelector('.btnholder a').href = dataurl;
      }
  })
});
// END CUSTOM TAB COLLECTIONS

const btn = document.querySelector('button[data-add-to-cart]');
const formWrapper = document.querySelector('.form__wrapper[data-form-wrapper]');

if (btn && formWrapper) {
  // Set the correct class based on initial state BEFORE observing
  formWrapper.classList.toggle('variant--soldout', btn.hasAttribute('disabled'));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
        const isDisabled = btn.hasAttribute('disabled');

        // Only act if the state actually changed
        if (mutation.oldValue === null && !isDisabled) continue;
        if (mutation.oldValue !== null && isDisabled) continue;

        formWrapper.classList.toggle('variant--soldout', isDisabled);
      }
    }
  });

  observer.observe(btn, {
    attributes: true,
    attributeFilter: ['disabled'],
    attributeOldValue: true  // Needed to access mutation.oldValue
  });
} else {
  console.warn('Button or form wrapper not found.');
}